// i18n.js
import { createI18n } from 'vue-i18n';
import EN from './locale/en.json';
import BN from './locale/bn.json';
import { helperStore } from "@/store/helper"
const helper = helperStore()

const i18n = createI18n({
    legacy: false,
    locale: helper.locale,
    fallbackLocale: 'EN',
    messages: {
        EN:EN,
        BN:BN,
    }
})

export default i18n;
